export function hexToRgb(
	hex: string,
): {r: number; g: number; b: number} | null {
	const match = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex)
	if (!match?.[1] || !match[2] || !match[3]) return null
	return {
		r: Number.parseInt(match[1], 16),
		g: Number.parseInt(match[2], 16),
		b: Number.parseInt(match[3], 16),
	}
}

export function isValidHex(hex: string): boolean {
	return /^#[0-9a-f]{6}$/i.test(hex)
}

export function deriveCssVars(hex: string) {
	const rgb = hexToRgb(hex)
	if (!rgb) return null
	const {r, g, b} = rgb
	return {
		'--mat-primary': hex,
		'--mat-primary-hover': `rgba(${r}, ${g}, ${b}, 0.05)`,
		'--mat-primary-bg': `rgba(${r}, ${g}, ${b}, 0.10)`,
	}
}
